module.exports = __webpack_public_path__ + "static/media/white-trillium-plant.3f8d8083.jpg";